import { useState } from 'react'
import { ArraySourceComposer } from '@/auth/api/connector'
import { ticket, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { useQuery } from '@tanstack/react-query'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { GlobalLoadingComponent } from '@/components/GlobalLoadingComponent/GlobalLoadingComponent'
import { Button, Form, Lookup } from 'devextreme-react'
import { AssignToMutationParams, useTicketAssignToMutation } from '@/routes/tickets/utils/mutations'
import notify from 'devextreme/ui/notify'
import { PopupRef } from 'devextreme-react/cjs/popup'
import React from 'react'
import { isUserRoleAllowed } from '@/routes/utils'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { Roles } from '@/auth/azure/Roles'

interface AssignSelectorProps {
  ticket: ticket | null | undefined
  popupAssignRef: React.RefObject<PopupRef>
  clientId?: string
  onAssigned?: (assignee: user) => void
}

export const AssignSelector: React.FC<AssignSelectorProps> = ({ ticket, popupAssignRef, clientId, onAssigned }) => {
  const { client } = useQsAdminApiManager()
  const assignToMutation = useTicketAssignToMutation(clientId)
  const { data: impiegatiData, isLoading } = useQuery({
    queryKey: ['impiegati_qs_attivi_nocontractor'],
    queryFn: async () => {
      const userInfo = await getAzureUserInformation()
      if (isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.Supervisor, Roles.Administrator])) {
        const result = await useQsAdminApiManager
          .getState()
          .service.user()
          .query((builder, user) => {
            builder.filter(
              user.attivo.eq(true).and(user.azienda.props.p_iva.eq('01955220346')).and(user.contractor.eq(false)),
            )
            builder.orderBy(user.fullname.asc())
          })
        return result.data.value
      } else {
        // L'elenco dei referenti (ruoli inclusi) è calcolato dal backend
        const response = await client.get('/api/tickets/referents')
        return response.data as user[]
      }
    },
  })
  const [impiegato, setImpiegato] = useState<user | null>(null)

  if (isLoading) {
    return <GlobalLoadingComponent />
  }
  if (!ticket) {
    return <div>Ticket non trovato</div>
  }
  return (
    <>
      <div id="assignto-selector-form-container" className={'responsive-paddings'}>
        <form
          className="dx-form"
          onSubmit={(e) => {
            e.preventDefault()
            try {
              if (impiegato && ticket) {
                console.log('Selector popup: Assegnando ticket a:', impiegato)
                assignToMutation.mutate({
                  ticketRecordId: ticket.id,
                  assigneeUser: impiegato,
                } satisfies AssignToMutationParams)
                onAssigned?.(impiegato)
              }
            } catch (error: unknown) {
              notify(`Errore assegnazione ticket '${ticket?.ded_Dis}'. Dettagli : ${error}`, 'error', 2000)
            } finally {
              popupAssignRef.current?.instance().hide()
            }
          }}
        >
          <div className="dx-field dx-col">
            <Lookup
              id="assignto-selector"
              className="dx-texteditor dx-texteditor-with-clear-button dx-lookup"
              dataSource={ArraySourceComposer('id', impiegatiData)}
              displayExpr="fullname"
              placeholder="Assegna a..."
              showClearButton={true}
              searchEnabled={true}
              width="100%"
              onValueChanged={(e) => {
                setImpiegato(e.value)
                console.log('Impiegato selezionato da popup:', e.value)
              }}
            />
          </div>
          <Button
            className="dx-button dx-button-success dx-button-normal dx-button-mode-contained dx-widget"
            type="success"
            useSubmitBehavior={true}
            disabled={!impiegato}
            text="Assegna"
            icon="check"
          />
        </form>
      </div>
    </>
  )
}
